import { useEffect } from 'react'
import Cookies from 'universal-cookie'
import { cookiesKeyNames } from '@revbox/common-fe'
import { getPublisherIdFromStorage, setPublisherIdFromSearch } from '@revbox/helpers-fe'
import { isCookiesEnabled, getPathKey } from '../contexts/CookiesContext'
import { safeParse } from '@helpers/json-helper'

const cookies = new Cookies()


export function usePublisherSetup() {
    const publisher_id = getPublisherIdFromStorage()
    const pathKey = getPathKey()
    useEffect(() => {
        if (publisher_id) {
            setPublisherIdFromSearch(publisher_id)
            let skinMode = undefined

            if (isCookiesEnabled) {
                skinMode = cookies.get(pathKey)[cookiesKeyNames?.skinMode]
            } else {
                skinMode = safeParse(localStorage.getItem(pathKey) || '{}')[cookiesKeyNames?.skinMode]
            }

            let HTMLTag = document.querySelector('html')

            if (skinMode) {
                HTMLTag.setAttribute('data-skin', skinMode)
            }
        }

        let brand = 'Revbox'
        if (['68', '34', '73'].includes(publisher_id)) {
            brand = 'Netnetix'
        }

        document.title = `${brand} - Publisher Monetization Suite`
    }, [publisher_id])

    const cookieData = cookies.get(pathKey)
    const languageKey = cookiesKeyNames?.language
    const language = languageKey && cookieData?.[languageKey]?.value ? cookieData[languageKey].value : 'EN'

    return { language, publisher_id }
}
